<template>
  <div class="c-main">
    <form action="#" class="c-main--flex-1 u-margin-bottom-large">
      <h2 class="c-title c-title--page">Invoicing</h2>

      <div class="o-layout">
        <div class="o-layout__item u-1-of-2-at-small">
          <div class="c-input p-date-picker">
            <label class="c-input__label" for="dates">{{ $t('date') }}</label>
            <HotelDatePicker format="DD - MMM - YYYY" id="dates" name="dates" :startingDateValue="fromDate"
                             :endingDateValue="toDate" :startDate="new Date(2015,1,1)" :endDate="dateEndDate()"
                             :showYear="true" :i18n="$options.labelsDatePicker" :minNights="0" :firstDayOfWeek="1"
                             @check-in-changed="updateFromDate($event)" @check-out-changed="updateToDate($event)"
            />
          </div>
        </div>
        <div class="o-layout__item">
          <sceButton class="c-button--primary c-button--large" v-on:click="fetch()" label="download"/>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HotelDatePicker from "vue-hotel-datepicker"
import moment from "moment/moment"
import lang from "@/lang"
import config from "@/config"
import report from "@/lib/report";

export default {
  name: "invoicing",
  components: {
    HotelDatePicker: HotelDatePicker,
  },
  data: function() {
    return {
      fromDate: null,
      toDate: null,
    }
  },
  created: function() {
    this.$options.labelsDatePicker = {
      night: this.$t('day'),
      nights: this.$t('days'),
      'day-names': lang.getDays(),
      'check-in': this.$t('date.start').trim(),
      'check-out': this.$t('date.end').trim(),
      'month-names': lang.getMonths(),
    }

    this.fromDate = moment().startOf('year').toDate()
    this.toDate = new Date()
  },
  methods: {
    updateFromDate: function (newDate) {
      this.fromDate = newDate
    },
    updateToDate: function (newDate) {
      this.toDate = newDate
    },
    dateEndDate: function () {
      return moment().add(1, 'years').toDate()
    },
    fetch: function() {
      const params = {
        dateFrom: moment(this.fromDate).format('YYYY-MM-DD'),
        dateTo: moment(this.toDate).format('YYYY-MM-DD'),
      }
      this.$http.get(config.root + '/organisations/eventSummaries', {params}).then(response => {
        const fields = [
          {
            label: 'Customer',
            value: 'customer',
          },
          {
            label: 'Date From',
            value: 'date_from',
          },
          {
            label: 'Date To',
            value: 'date_to',
          },
          {
            label: 'Title',
            value: 'title',
          },
          {
            label: 'Discipline',
            value: 'disciplines.discipline',
          },
          {
            label: 'Disc Title',
            value: 'disciplines.name',
          },
          {
            label: 'Total',
            value: 'disciplines.individual.total',
          },
          {
            label: 'Present',
            value: 'disciplines.individual.present',
          },
          {
            label: 'Reserve',
            value: 'disciplines.individual.reserve',
          },
          {
            label: 'Absent',
            value: 'disciplines.individual.absent',
          },
          {
            label: 'Teams',
            value: 'disciplines.team.total',
          },
        ]
        const unwind = ['disciplines']
        console.log(response.data)
        report.publishCSV2(response.data, fields, 'competitions', unwind)
      })
    },
  },
}
</script>

<style scoped>

</style>
